import { PrivateRoute } from '_app/components/PrivateRoute'
import { SnackbarProvider } from '_app/context/SnackbarContext'
import { AppProvider } from '_app/context/AppContext'
import { Theme } from '_app/theme/theme'
import { swrConfig } from '_app/utils/swrConfig'
import LoadingPage from 'common/components/LoadingPage'
import { ConfirmProvider } from 'material-ui-confirm'
import { parse, stringify } from 'query-string'
import { Suspense } from 'react'
import { Outlet } from 'react-router-dom'
import { BillingProvider } from 'settings/billing/context/Billing.context'
import { SWRConfig } from 'swr'
import { QueryParamProvider } from 'use-query-params'
import { ReactRouter6Adapter } from 'use-query-params/adapters/react-router-6'

/**
 * This is the root component for the app. It wraps the entire app with all required providers
 */
const Root = () => {
  return (
    <Theme>
      <ConfirmProvider>
        <SWRConfig value={swrConfig}>
          <QueryParamProvider
            adapter={ReactRouter6Adapter}
            options={{
              searchStringToObject: parse,
              objectToSearchString: stringify,
            }}
          >
            <AppProvider>
              <SnackbarProvider>
                <BillingProvider>
                  <PrivateRoute>
                    <Suspense fallback={<LoadingPage />}>
                      <Outlet />
                    </Suspense>
                  </PrivateRoute>
                </BillingProvider>
              </SnackbarProvider>
            </AppProvider>
          </QueryParamProvider>
        </SWRConfig>
      </ConfirmProvider>
    </Theme>
  )
}

export default Root
